<template>
  <!-- 二次报价 -->
  <div>
      <!-- 主持人 -->
      <template v-if="role == 'Z'" >
        <z @nextBtn="nextBtn" ></z>
      </template>
      <!-- 招标代理 -->
      <template v-else>
        <d></d>
      </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
    };
  },
  components: {
    z: () => import("./components/role_z.vue"),
    d: () => import("./components/role_d.vue"),
  },
  created() {},
  methods: {
    nextBtn(para) {
      this.$emit("nextBtn", para);
    },

  },
};
</script>

<style lang='scss' scoped>
</style>
